var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"obody"},[_c('div',{staticClass:"tab"},_vm._l((_vm.list),function(it,index){return _c('div',{key:index,staticClass:"tabOpt",class:{ act: _vm.val == it.value },on:{"click":function($event){_vm.$emit('update:val', it.value);
        _vm.fun();}}},[_c('span',[_vm._v(_vm._s(it.name))])])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }